import React, { useEffect, useState } from "react";
import Header from "../../components/template/estimate/Header";
import MoveInfo from "../../components/summary/MoveInfo";
import InventoryList from "../../components/summary/InventoryList";
import ProgressBar from "../../components/template/ProgressBar";
import { useSelector, useDispatch } from "react-redux";
import { thunkLoadMoveInfoFromSession } from "../../redux/reducers/move_info/moveInfoReducer";
import { thunkLoadPropertyInfoFromSession } from "../../redux/reducers/property_info/propertyInfoReducer";
import { loadFromSession } from "../../redux/reducers/inventory/inventoryReducer";
import LoginModal from "../../components/inventory/Modal/LoginModal";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export default function Summary() {
  const dispatch = useDispatch();
  const history = useHistory();
  const moveInfo = useSelector((state) => state.moveInfo);
  const propertyInfo = useSelector((state) => state.propertyInfo);
  const inventoryInfo = useSelector((state) => state.inventoryInfo);
  const [additionalData, setAdditionalData] = useState("");
  const [loginModal, setLoginModal] = useState(false);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (
      moveInfo.hasLoadedFromSession === false &&
      sessionStorage.getItem("move_info") !== null
    ) {
      const moveInfo = sessionStorage.getItem("move_info");
      dispatch(thunkLoadMoveInfoFromSession({ moveInfo: moveInfo }));
    }
    if (
      propertyInfo.hasLoadedFromSession === false &&
      sessionStorage.getItem("property_info") !== null
    ) {
      const propertyInfo = sessionStorage.getItem("property_info");
      dispatch(
        thunkLoadPropertyInfoFromSession({ propertyInfo: propertyInfo })
      );
    }
    if (
      inventoryInfo.get("inventory").size === 0 &&
      sessionStorage.getItem("inventory_info") !== null
    ) {
      const inventoryInfo = JSON.parse(
        sessionStorage.getItem("inventory_info")
      );
      dispatch(loadFromSession(inventoryInfo));
    }
    if (sessionStorage.getItem("summaryInfo") !== null) {
      const summaryInfo = JSON.parse(sessionStorage.getItem("summaryInfo"));
      setAdditionalData(summaryInfo.additionalInfo);
    }
  }, [
    dispatch,
    inventoryInfo,
    propertyInfo.hasLoadedFromSession,
    moveInfo.hasLoadedFromSession,
  ]);
  const saveAdditionalInfoToSession = (props) => {
    const gotoPage = props.gotoPage;
    const summaryInfo = { additionalInfo: additionalData };
    sessionStorage.setItem("summaryInfo", JSON.stringify(summaryInfo));
    history.push(gotoPage);
  };

  const JSX = (
    <React.Fragment>
      <Header
        currentPage="summary"
        referenceToSubmit={saveAdditionalInfoToSession}
      />
      <main className="container">
        <div>
          <section class="progress-bar-section">
            <div class="row align-items-center justify-content-center">
              <div class="col-sm-12 col-md-12 col-lg-9">
                <ProgressBar
                  currentPage="summary"
                  referenceToSubmit={saveAdditionalInfoToSession}
                />
              </div>
            </div>
          </section>
        </div>
        <div className="summary-container">
          <section className="heading">
            <h3> Your move summary </h3>
          </section>
          <MoveInfo
            additionalState={{ additionalData, setAdditionalData }}
            authSubmit={{ loginModal, setLoginModal }}
            editInventoryNavFn={(data) => {
              saveAdditionalInfoToSession(data);
            }}
          />
          <section className="items-info">
            <div className="mb-4 d-flex align-items-center justify-content-start">
              <h3 className="m-0"> Your Inventory List </h3>
              <button
                className="btn btn-sm ml-3 show-all-eye"
                onClick={() => {
                  setShowAll(!showAll);
                }}
              >
                {showAll === false && <FontAwesomeIcon icon={faEyeSlash} />}
                {showAll === true && <FontAwesomeIcon icon={faEye} />}
              </button>
            </div>
            <div className="accordian pb-5">
              <InventoryList showAll={showAll} />
            </div>
          </section>
        </div>
        {loginModal === true && (
          <LoginModal
            isOpen={loginModal}
            additionalInfo={additionalData}
            isSkipInventory={false}
            toggle={() => {
              setLoginModal(false);
            }}
          />
        )}
      </main>
    </React.Fragment>
  );
  return JSX;
}
